/** Cliché `document_submits.serialization` / publications versionnées (v1). */
export const SUBMIT_SNAPSHOT_VERSION = 1 as const;

export type StoredSnapshotV1 = {
  snapshotVersion: typeof SUBMIT_SNAPSHOT_VERSION;
  document: {
    name: string;
    extension: string;
    serialization: unknown;
    strictValidation: boolean;
  };
  values: Array<{
    valueId: string;
    serialization: unknown;
    siteIds: string[];
    moduleIds: string[];
    itemSiteModules: Array<{
      itemRef: string;
      siteIds: string[];
      moduleIds: string[];
    }>;
  }>;
};

export function parseStoredSnapshotV1(raw: unknown): StoredSnapshotV1 | null {
  if (!raw || typeof raw !== 'object') return null;
  const o = raw as Record<string, unknown>;
  if (o.snapshotVersion !== SUBMIT_SNAPSHOT_VERSION) return null;
  const doc = o.document;
  if (!doc || typeof doc !== 'object') return null;
  const d = doc as Record<string, unknown>;
  if (
    typeof d.name !== 'string' ||
    typeof d.extension !== 'string' ||
    typeof d.strictValidation !== 'boolean'
  ) {
    return null;
  }
  const valuesRaw = o.values;
  if (!Array.isArray(valuesRaw)) return null;
  const values: StoredSnapshotV1['values'] = [];
  for (const vr of valuesRaw) {
    if (!vr || typeof vr !== 'object') return null;
    const v = vr as Record<string, unknown>;
    if (typeof v.valueId !== 'string') return null;
    const siteIds = v.siteIds;
    const moduleIds = v.moduleIds;
    const ism = v.itemSiteModules;
    if (!Array.isArray(siteIds) || !siteIds.every((x) => typeof x === 'string')) return null;
    if (!Array.isArray(moduleIds) || !moduleIds.every((x) => typeof x === 'string')) return null;
    if (!Array.isArray(ism)) return null;
    const itemSiteModules: StoredSnapshotV1['values'][number]['itemSiteModules'] = [];
    for (const row of ism) {
      if (!row || typeof row !== 'object') return null;
      const r = row as Record<string, unknown>;
      if (typeof r.itemRef !== 'string') return null;
      const s = r.siteIds;
      const m = r.moduleIds;
      if (!Array.isArray(s) || !s.every((x) => typeof x === 'string')) return null;
      if (!Array.isArray(m) || !m.every((x) => typeof x === 'string')) return null;
      itemSiteModules.push({ itemRef: r.itemRef, siteIds: s, moduleIds: m });
    }
    values.push({
      valueId: v.valueId,
      serialization: v.serialization ?? null,
      siteIds,
      moduleIds,
      itemSiteModules,
    });
  }
  return {
    snapshotVersion: SUBMIT_SNAPSHOT_VERSION,
    document: {
      name: d.name,
      extension: d.extension,
      serialization: d.serialization ?? null,
      strictValidation: d.strictValidation,
    },
    values,
  };
}
